import createEventLogLifecyclePlugin from './lifecycle.js'

const eventLogLifecyclePluginDefinition = {
  id: 'eventLogLifecyclePlugin',
  type: 'plugin',
  factory: createEventLogLifecyclePlugin,
  dependencies: ['config', 'getBuildMetadata', 'eventLog'],
  public: true,
}

export default eventLogLifecyclePluginDefinition
